<template>
  <aside class="adBanner" :class="{ '-noPadding': adType === 'searchResult' }">
    <router-link
      :to="`/search/hospital/detail/${item.hospital_id}`"
      class="link"
    >
      <picture>
        <source media="(max-width: 899px)" :srcset="item.op_web_sp_img" />
        <img :src="item.op_web_pc_img" :alt="item.hospital_name" />
      </picture>
    </router-link>
  </aside>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export interface AdBannerType {
  hospital_id: number
  hospital_name: string
  op_web_pc_img: string
  op_web_sp_img: string
}

export default defineComponent({
  name: 'AdBanner',

  props: {
    item: {
      type: Object as PropType<AdBannerType>,
      default: () => ({})
    },
    adType: {
      type: String
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.adBanner {
  padding: 0 16px;
  width: 100%;
  max-width: 712px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  @include mixins.media() {
    max-width: 752px;
    padding: 0 20px;
  }

  &.-noPadding {
    padding: 0;
  }
}

.link {
  display: inline-block;
  // background-color: #fffccb;
}
</style>
